import React from 'react'
import { setOptInOut } from '@fs/zion-soft-launch'
import { useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, Image, Paragraph, Separator } from '@fs/zion-ui'
import { useOverlayContext } from '../../providers/overlayContextProvider/OverlayContext'
import IndexingIllustration from './IndexingIllustration.png'

const EnableAttachFlowFlagOverlay = ({ overlay }) => {
  const [t] = useTranslation()
  const { openOverlay } = useOverlayContext()

  return (
    <DialogOverlay {...overlay} title={t('enable-full-text-flag-overlay.title', 'Try Our New Feature')}>
      <Image src={IndexingIllustration} />
      <Separator size="sm" />
      <Paragraph size="sm">
        {t(
          'enable-full-text-flag-overly.content1',
          "The Full-Text transcript isn't in the same format as the data in Family Tree. We have a new process that allows you to add names and events to accurately build and improve your tree."
        )}
      </Paragraph>
      <Paragraph size="sm">
        {t(
          'enable-full-text-flag-overly.content2',
          "If you're short on time, you will still have access to attach the image as a source without adding information to your tree."
        )}
      </Paragraph>
      <DialogOverlayActions>
        <Button
          onClick={() => {
            // Traditional flow
            openOverlay('mainInfosheet')
            openOverlay('attachToTreeOverlay')
            setOptInOut({
              newPref: false,
              featureFlag: 'rip_sharedImageViewer_fullTextAttachFlow_v1',
              reloadPage: false,
            })
            localStorage.setItem('rip:viewedEnableAttachFlowFlagOverlay', 'true')
            overlay.close()
          }}
          linkName="Enable Full Text FLag Overlay Back"
          data-testid="enable-full-text-flag-not-now"
        >
          {t('enable-full-text-flag-overlay.not-now-btn', 'Not Now')}
        </Button>
        <Button
          emphasis="high"
          linkName="Enable Full Text Flag Overlay Confirm"
          data-testid="disable-full-text-flag-try-it"
          onClick={() => {
            overlay.close()
            setOptInOut({
              newPref: true,
              featureFlag: 'rip_sharedImageViewer_fullTextAttachFlow_v1',
            })
            localStorage.setItem('rip:viewedEnableAttachFlowFlagOverlay', 'true')
          }}
        >
          {t('enable-full-text-flag-overlay.try-it-btn', 'Try It')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}

export default EnableAttachFlowFlagOverlay
